import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent } from 'react';
import { ThemeProvider } from 'styled-components';
import { Grid } from '@atlaskit/page';
import ProgressTrackerLink from '../ProgressTrackerLink';
import ProgressTrackerStage from '../ProgressTrackerStage';
import { ProgressTrackerContainer } from './styled';
const TRANSITION_SPEED = 300;
const LINEAR_TRANSITION_SPEED = 50;
const easeOut = 'cubic-bezier(0.15,1,0.3,1)';
const defaultLabel = 'Progress';
export default class ProgressTracker extends PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "createTheme", () => ({
      spacing: this.props.spacing,
      columns: this.props.items.length * 2
    }));

    _defineProperty(this, "state", {
      prevStages: this.props.items.map((stage, index) => ({ ...stage,
        percentageComplete: 0
      }))
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const prevStages = nextProps.items.map(stage => {
      const oldStage = this.props.items.find(st => st.id === stage.id);
      return oldStage !== undefined ? oldStage : stage;
    });
    this.setState({
      prevStages
    });
  }

  render() {
    const {
      testId,
      label
    } = this.props;
    const progressChanges = this.props.items.filter((stage, index) => stage.percentageComplete !== this.state.prevStages[index].percentageComplete).length;
    const totalStepsForward = this.props.items.filter((stage, index) => stage.percentageComplete > this.state.prevStages[index].percentageComplete).length;
    const totalStepsBack = this.props.items.filter((stage, index) => stage.percentageComplete < this.state.prevStages[index].percentageComplete).length;
    let stepsForward = totalStepsForward;
    let stepsBack = totalStepsBack;
    const items = this.props.items.map((stage, index) => {
      let transitionSpeed = 0;
      let transitionDelay = 0;
      const transitionEasing = progressChanges > 1 ? 'linear' : easeOut;

      if (this.props.animated) {
        transitionSpeed = progressChanges > 1 ? LINEAR_TRANSITION_SPEED : TRANSITION_SPEED;

        if (stage.percentageComplete < this.state.prevStages[index].percentageComplete) {
          /** load each transition sequentially in reverse */
          transitionDelay = (stepsBack - 1) * transitionSpeed;
          stepsBack -= 1;
        } else if (stage.percentageComplete > this.state.prevStages[index].percentageComplete) {
          /** load each transition sequentially */
          transitionDelay = (totalStepsForward - stepsForward) * transitionSpeed;
          stepsForward -= 1;
        }
      }

      return /*#__PURE__*/React.createElement(ProgressTrackerStage, {
        key: stage.id,
        item: stage,
        render: this.props.render,
        transitionSpeed: transitionSpeed,
        transitionDelay: transitionDelay,
        transitionEasing: transitionEasing
      });
    });
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: this.createTheme()
    }, /*#__PURE__*/React.createElement(Grid, {
      testId: testId
    }, /*#__PURE__*/React.createElement(ProgressTrackerContainer, {
      "aria-label": label
    }, items)));
  }

}

_defineProperty(ProgressTracker, "defaultProps", {
  items: [],
  spacing: 'cosy',
  render: {
    link: props => /*#__PURE__*/React.createElement(ProgressTrackerLink, props)
  },
  animated: true,
  label: defaultLabel
});